import { render, staticRenderFns } from "./RoleStatusSelector.vue?vue&type=template&id=220e59de&scoped=true&"
import script from "./RoleStatusSelector.vue?vue&type=script&lang=js&"
export * from "./RoleStatusSelector.vue?vue&type=script&lang=js&"
import style0 from "./RoleStatusSelector.vue?vue&type=style&index=0&id=220e59de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220e59de",
  null
  
)

export default component.exports